import { useMutation, useQueryClient } from '@tanstack/react-query';

import { teamApi } from '../api';
import { TEAM_DAY_QUERY_KEY, TEAM_DETAIL_QUERY_KEY, TEAM_LIST_QUERY_KEY } from '../queries';

interface DeleteTeamResult {
  teamId: string;
}

export const useDeleteTeam = () => {
  const queryClient = useQueryClient();

  const deleteTeamMutation = useMutation({
    mutationFn: (teamId: string) => {
      return teamApi.deleteTeam(teamId).then(({ data }) => {
        return {
          teamId: data.teamId,
        } as DeleteTeamResult;
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TEAM_LIST_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: TEAM_DETAIL_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: TEAM_DAY_QUERY_KEY });
    },
  });

  return {
    deleteTeam: deleteTeamMutation.mutateAsync,
    isDeletingTeam: deleteTeamMutation.isPending,
    ...deleteTeamMutation,
  };
};
